import { isUndefinedOrNullOrEmptyString } from "@/module/Validation/rules/isUndefinedOrNullOrEmptyString";

const validate = (value: any): boolean => {
  if (isUndefinedOrNullOrEmptyString(value)) {
    return false;
  }

  if (Array.isArray(value)) {
    return value.length > 0 && value.every((val) => validate(val));
  }

  value = String(value).replace(",", ".");

  if (value === "") {
    return false;
  }

  const number = Number(value);

  return !Number.isNaN(number);
};

export { validate };

export default {
  validate,
};
